import React from "react";

interface SummaryTotalsProps {
  sumNetto?: number;
  sumBrutto?: number;
  tax?: number;
  taxRate?: number;
}

const format = (val?: number) =>
  String(val == null ? "0,0" : val.toFixed(2)).replace(".", ",");

const SummaryTotals: React.FC<SummaryTotalsProps> = ({ sumNetto, sumBrutto, tax, taxRate = 19 }) => {
  return (
    <div className="summary-container">
      <div className="summary-title-mobile">Zusammenfassung:</div>
      <div className="summary-mobile-content">
        <div>{format(sumNetto)} € ohne MwSt.</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>+</span>
          <span>{format(tax)} € MwSt. {taxRate}%</span>
        </div>
        <div style={{ borderTop: "1px solid black", paddingTop: "4px", marginTop: "4px", fontWeight: "bold" }}>
          {format(sumBrutto)} € inkl. MwSt.
        </div>
      </div>
      {/* Kolumny z kwotami mają szerokość treści (bez łamania linii) i kończą się
          przy prawej krawędzi w obu wierszach, więc zawsze są wyrównane. */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          padding: "20px 20px 0 20px",
        }}
        className="summary-first-row"
      >
        <div style={{ flex: "1 1 auto" }}></div>
        <div style={{ color: "black", whiteSpace: "nowrap", marginRight: "24px" }} className="is-size-6 has-text-weight-bold summary-title-desktop">
          <span style={{ fontWeight: "normal" }}>Zusammenfassung:</span>
        </div>
        <div style={{ flex: "0 0 auto", minWidth: "25%", color: "black", borderBottom: "black solid 1px", display: "flex" }} className="is-size-6 has-text-weight-bold summary-details">
          <div style={{ textAlign: "left", marginTop: "auto", paddingRight: "12px" }} className="summary-plus">+</div>
          <div style={{ flex: "1 1 auto", textAlign: "right", whiteSpace: "nowrap" }} className="summary-amounts">
            {format(sumNetto)} € ohne MwSt.
            <br />
            {format(tax)} € MwSt. {taxRate}%
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          padding: " 0 20px 20px 20px",
        }}
        className="summary-second-row"
      >
        <div style={{ flex: "1 1 auto" }}></div>
        <div style={{ flex: "0 0 auto", minWidth: "25%", color: "black", textAlign: "right", whiteSpace: "nowrap", paddingTop: "6px" }} className="is-size-6 has-text-weight-bold summary-total">
          {format(sumBrutto)} € inkl. MwSt.
        </div>
      </div>
    </div>
  );
};

export default SummaryTotals;
